import { FC } from 'react';
import { Text } from '@mofid-securities/uikit';
import { LinkButton } from '@/components/Button';
import { useGetTransactionsListUrl } from '../hooks/useGetTransactionsListUrl';

export const ShowTransactions: FC = () => {
  const url = useGetTransactionsListUrl();

  return (
    <div className="flex items-center justify-between">
      <Text
        className="text-gray-filled-primary-enabled"
        size="xs"
        weight="medium"
      >
        تراکنش های فعال
      </Text>
      <LinkButton href={url}>همه تراکنش ها</LinkButton>
    </div>
  );
};
